<template>
  <div
    v-if="active"
    class="m-market-row"
  >
    <Outcome
      v-for="id in market.outcomes.order"
      :key="id"
      class="has-desc"
      :outcome="market.outcomes.map[id]"
      :market="market"
      :event="event"
      :description="getCustomDesc(market.outcomes.map[id].description)"
      show-desc
    />
  </div>
</template>

<script>
import Outcome from 'wap/match/Event/pagelet/Outcome'

const checkIsActive = (status) => {
  return +status === 0 || +status === 1
}

export default {
  components: {
    Outcome
  },
  props: {
    event: {
      type: Object,
      default: () => ({})
    },
    market: {
      type: Object,
      default: () => ({})
    }
  },
  setup() {
    const getCustomDesc = (description = '') => {
      return description.match(/\((.*)\)/)[1]
    }
    return {
      getCustomDesc
    }
  },
  data() {
    return {
      timer: null,
      active: true
    }
  },
  watch: {
    'market.status'(val) {
      this.timer && clearTimeout(this.timer)
      if (checkIsActive(val)) {
        this.active = true
      } else {
        this.timer = setTimeout(() => {
          this.active = false
        }, 5000)
      }
    }
  }
}
</script>
